/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

/** Models */
import { DsPinStatus } from '../models/ds-pin-status';

/** Interfaces */
import { DsPinStatusInterface } from '../interfaces/ds-pin-status.interface';

/** Functions */
import { getCustomPinStatus } from '../functions/getCustomPinStatus.function';

/** Sixense */
import { BydModel } from '@sixense/byd-core-service';

@Injectable({
  providedIn: 'root',
})
export class DsPinStatusService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get only customized status list.
   *
   * @param projectId Project ID
   * @returns Observable type `<BydModel<DsPinStatus>>`
   */
  public getStatusList(projectId: number): Observable<BydModel<DsPinStatus>> {
    this.path = `/v1/dspin/projects/${projectId}/pinstatus`;
    return this.getModels<DsPinStatus>().pipe(
      map((bydModel) => {
        bydModel.models = getCustomPinStatus(bydModel.models);
        return bydModel;
      })
    );
  }

  /**
   * Add status or edit if existing.
   *
   * @param projectId Current project ID
   * @param statusList List of the status to be updated/inserted
   * @returns Observable<boolean>
   */
  public editStatusList(projectId: number, statusList: DsPinStatus[]): Observable<BydModel<DsPinStatus>> {
    this.path = `/v1/dspin/projects/${projectId}/pinstatus`;

    return this.putModels<DsPinStatus>({ body: statusList }).pipe(
      map((bydModel) => {
        bydModel.models = getCustomPinStatus(bydModel.models);
        return bydModel;
      })
    );
  }

  /**
   * Create DsPinStatus instance.
   *
   * @param  pinStatus The flat json object.
   * @returns an `DsPinStatus` instance.
   */
  public createNewInstance(pinStatus: DsPinStatusInterface): DsPinStatus {
    return new DsPinStatus(pinStatus);
  }
}
